import React from 'react';
import PT from 'prop-types';
import { Button, Menu, Icon } from 'semantic-ui-react';
import { FilterMenuOptionsType } from '../../../lib/proptypes/semantic';
import classes from './filtersHeaderToggle.css';

const FiltersHeaderToggle = ({
  label,
  showFilters,
  onClick,
  className,
}) => (
  <div className={className}>
    <div className={classes.filterToggle}>
      <div
        className={showFilters ? classes.selected : classes.unselected}
        onClick={onClick}
      >
        <span className={classes.labelText}>{label}</span>
        <Icon className={classes.filterToggleIcon} name="options" />
      </div>
    </div>
  </div>
);

FiltersHeaderToggle.propTypes = {
  label: PT.string,
  showFilters: PT.bool,
  onClick: PT.func,
  className: PT.string,
};

FiltersHeaderToggle.defaultProps = {
  label: '',
  showFilters: true,
  className: null,
  onClick: () => true,
};

export default FiltersHeaderToggle;


// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/FiltersHeaderToggle.js